import { TextField as ODSTextField } from "@origin-digital/ods-core";
import { IconSearch } from "@origin-digital/ods-icons";
import styled from "styled-components";
import { IconButton, Paper, Popper } from "@mui/material";

export const StyledTextField = styled(ODSTextField)`
  .MuiInputBase-root {
    padding: 8px !important;
    border-radius: ${({ theme }) => theme.shape.borderRadii.medium}px;
    background-color: ${({ theme }) => theme.palette.background.default};
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: transparent;
  }

  .MuiInputBase-input::placeholder {
    color: ${({ theme }) => theme.colors.neutral};
    opacity: 1;
  }
`;

export const StyledSearchIcon = styled(IconSearch)`
  padding: 8px;
`;

export const CancelButtonContainer = styled("div")`
  transition: 0.1s ease;
  overflow: hidden;
  margin: auto 0;
`;

export const Container = styled("div")`
  z-index: 11;
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto;

  // show and hide the cancel button
  ${CancelButtonContainer} {
    max-width: 0px;
    opacity: 0;
  }

  ${({ theme }) => theme.breakpoints.down("lg")} {
    &:has(.MuiInputBase-root.Mui-focused) ${CancelButtonContainer} {
      max-width: 100px;
      opacity: 1;
      padding-left: 8px;
    }
  }
`;

export const StyledCancelIconButton = styled(IconButton)<{ open: boolean }>`
  transition: 0.2s ease;
  pointer-events: ${({ open }) => (open ? "initial" : "none")};
  opacity: ${({ open }) => (open ? 1 : 0)};
`;

export const StyledPopper = styled(Popper)`
  width: 100% !important;
  left: 0;
  right: 0;
`;

export const StyledPaper = styled(Paper)`
  padding: ${({ theme }) => `${theme.space.xlarge}px 46px`};

  .MuiAutocomplete-listbox {
    max-height: 100%;
  }
  .MuiAutocomplete-option {
    width: 100%;
    min-height: 48px;
    padding: 12px;
  }
`;

export const FullPageCoverContainer = styled("div")<{ show: boolean }>`
  ${({ theme }) => theme.breakpoints.down("lg")} {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100vh;
    background-color: ${({ theme }) => theme.palette.background.paper};
    z-index: 10;

    transition: opacity 0.2s ease-in-out;
    opacity: ${({ show }) => (show ? 1 : 0)};
    pointer-events: ${({ show }) => (show ? "initial" : "none")};
  }
`;
